module.exports = __webpack_public_path__ + "static/market-tile-2fbbfca247d5066baf78ebe352a9a4cb.png";